import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["vehicleFieldset", "driverFieldset", "repairShopFieldset", "typeSelect"];

  connect() {
    this.toggleFieldsets();
  }

  toggleFieldsets() {
    const value = this.typeSelectTarget.value;
    const isVehicle = value === "Veículo";

    this.vehicleFieldsetTarget.style.display = isVehicle ? "" : "none";
    this.driverFieldsetTarget.style.display = isVehicle ? "" : "none";
    this.repairShopFieldsetTarget.style.display = isVehicle ? "" : "none";
  }
}
